export const initDataTable = () => {
  const table = $('#templates,#drafts,#projects').DataTable({
    paging: false,
    order: [],
    stripeClasses: []
  });
  $('.dropdown-menu.columns-list li').each(function () {
    $(this).on('click', function (e) {
      e.preventDefault();
      $(this).parent().dropdown('show');

      if ($(this).parent().find('i.cil-check-alt').length === 1 && $(this).find('i').hasClass('cil-check-alt')) {
        return;
      }

      $(this).find('i').toggleClass('cil-check-alt');

      // Get the column API object
      var column = table.column($(this).attr('data-column'));

      // Toggle the visibility
      column.visible(!column.visible());
    })
  });
};
